import React from 'react';

export const BillingIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5 5.00014H2.5C1.83696 5.00014 1.20107 5.2636 0.732233 5.73244C0.263392 6.20128 0 6.83717 0 7.50021L0 12.5002C0 13.1632 0.263392 13.7991 0.732233 14.268C1.20107 14.7368 1.83696 15.0002 2.5 15.0002H17.5C18.163 15.0002 18.7989 14.7368 19.2678 14.268C19.7366 13.7991 20 13.1632 20 12.5002V7.50021C20 6.83717 19.7366 6.20128 19.2678 5.73244C18.7989 5.2636 18.163 5.00014 17.5 5.00014ZM2.5 6.66681H17.5C17.721 6.66681 17.933 6.75461 18.0893 6.91088C18.2455 7.06715 18.3333 7.27914 18.3333 7.50021V8.33348H1.66667V7.50021C1.66667 7.27914 1.75446 7.06715 1.91074 6.91088C2.06701 6.75461 2.279 6.66681 2.5 6.66681ZM17.5 13.3335H2.5C2.279 13.3335 2.06701 13.2457 1.91074 13.0894C1.75446 12.9332 1.66667 12.7212 1.66667 12.5002V10.0002H18.3333V12.5002C18.3333 12.7212 18.2455 12.9332 18.0893 13.0894C17.933 13.2457 17.721 13.3335 17.5 13.3335Z"
      fill="currentColor"
    />
  </svg>
);
